module.exports = __webpack_public_path__ + "img/om_qr_xiaochengxu.150936a6.png";